import React from 'react';
import { Icon } from '..';

export const CustomArrow = ({ ...props }): JSX.Element => {
	const { className, styles, onClick } = props;
	return (
		<div onClick={onClick}>
			<Icon name="carousel-arrow" className={className} style={{ ...styles }} />
		</div>
	);
};
